<header class="header">
    <div class="header-row">
        <div class="logo">
            <a class="logo-link" routerLink="dashboard">
                <img class="{{ logoStyle }}" src="{{ logoImage }}" alt="{{ logoAlt }}" />
            </a>
        </div>

        <div class="header-actions">
            <app-configurator-3d-btn />
            @if (metalOrderEnabled && canBuyMetals) {
                <app-metal-order-btn />
            }
        </div>

        <div class="header-tools">
            @if (hasChainStoreManagerRole && (invoiceState$ | async); as invoiceState) {
                @if (invoiceState.late > 0) {
                    <div>
                        <a [routerLink]="['/invoices']" class="invoice-warning">
                            {{ 'CLIENT.INVOICES.unpaid_warning' | translate }}
                        </a>
                        <a [routerLink]="['/invoices']" class="invoice-warning-mobile">
                            <i title="{{ 'CLIENT.INVOICES.unpaid_warning' | translate }}" class="invoice-warning-icon pi pi-wallet"></i>
                        </a>
                    </div>
                }
            }

            <ul class="tools-list">
                @if ((disclosure$ | async) === true) {
                    @if (demo === false && (materialState$ | async); as materialState) {
                        @if (materialState.active === true) {
                            <li class="material">
                                <p-badge
                                    value="{{ 'HEADER.material-state' | translate }}: {{ materialState.grams | number: '1.2-2' }}g"
                                    [severity]="materialState.grams < 0 ? 'danger' : 'success'"
                                    size="large"
                                />
                            </li>
                        }
                    }
                }

                <li data-hj-suppress class="user">
                    <app-user-info />
                </li>
                <li class="cog">
                    <p-button
                        routerLink="profile"
                        icon="pi pi-cog"
                        severity="secondary"
                        [text]="true"
                        [rounded]="true"
                        [ariaLabel]="'HEADER.BUTTONS.TITLE.settings' | translate"
                        [pTooltip]="'HEADER.BUTTONS.TITLE.settings' | translate"
                        tooltipPosition="bottom"
                        appendTo="body"
                    />
                </li>
                <li>
                    <p-button
                        [routerLink]="['/logout']"
                        skipLocationChange
                        icon="pi pi-power-off"
                        severity="secondary"
                        [text]="true"
                        [rounded]="true"
                        [ariaLabel]="'HEADER.BUTTONS.TITLE.logout' | translate"
                        [pTooltip]="'HEADER.BUTTONS.TITLE.logout' | translate"
                        tooltipPosition="bottom"
                        appendTo="body"
                    />
                </li>
            </ul>
        </div>
    </div>
</header>
